@if (!showErrorMsg && iframeURL) {
  <iframe
    [src]="iframeURL"
    style="height: 100vh;width:100%"
    frameborder="0"
    allow="microphone *; camera *;"
    title="Dev Space iframe"
  ></iframe>
}
@if (showErrorMsg) {
  <section fxLayout="column" fxLayoutAlign="center center">
    <div class="card-content">
      <h3>DevSpace Launch Error</h3>
      <p>Service Unavailable: Error Logging in DevSpace User.</p>
      <p>Reload the page to try relaunching DevSpace. If this problem persists please contact the <a href="https://support.emcschool.com/help/contact-us/" target="_blank">Technical Support Team</a></p>
    </div>
  </section>
}
